import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useParams } from 'react-router-dom';
import { useWorkspace } from '../../lib/workspace';
import { useApi } from '../../lib/api';

export default function Home() {
  const { appId } = useParams();
  const api = useApi();
  const { myRole } = useWorkspace();
  const isMember = myRole === 'member';

  const [canSeeManager, setCanSeeManager] = useState(false);

  useEffect(() => {
    api.hasTeam(appId)
      .then((res) => setCanSeeManager(!!res.has_team))
      .catch(() => setCanSeeManager(false));
  }, [api, appId]);

  const showTabs = canSeeManager;

  return (
    <div className="setup-page">
      <h1 className="page-title">Home</h1>
      <p className="page-subtitle">Your personal workspace — tasks, performance, hours, and activity all in one place.</p>
      {showTabs && (
        <div className="setup-tabs" role="tablist">
          <NavLink
            to={`/apps/${appId}/home/my`}
            className={({ isActive }) => `setup-tab${isActive ? ' active' : ''}`}
            role="tab"
          >
            My Dashboard
          </NavLink>
          {canSeeManager && (
            <NavLink
              to={`/apps/${appId}/home/manager`}
              className={({ isActive }) => `setup-tab${isActive ? ' active' : ''}`}
              role="tab"
            >
              Manager Dashboard
            </NavLink>
          )}
        </div>
      )}
      <div className="setup-tab-body">
        <Outlet />
      </div>
    </div>
  );
}
